exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div.tonnage-distribution {\n  display: flex;\n  max-height: 40px;\n  text-align: center;\n  padding: 0; }\n  div.tonnage-distribution div.tonnage-info {\n    color: #fff; }\n    div.tonnage-distribution div.tonnage-info span.tonnage-label {\n      padding-top: 2px;\n      font-size: 12px;\n      display: inherit; }\n", ""]);

